// export const API_BASE_URL = 'http://127.0.0.1:8000/simplydocApi'; //local
// export const API_BASE_URL = 'http://10.1.100.216:8001/simplydocApi'; //hosted dev
// export const API_BASE_URL = 'http://10.1.100.163:8001/simplydocApi'; //hosted prod

// const API_ENV =
//   window.location.hostname === '10.1.100.163' || window.location.hostname === 'srvdtiprodlnx1'
//     ? 'http://10.1.100.163:8001/simplydocApi'
//     : 'http://10.1.100.216:8001/simplydocApi';
const API_ENV =
  window.location.hostname === '10.1.100.163' || window.location.hostname === 'srvdtiprodlnx1' || window.location.hostname === 'simplydoc.ai'
    ? 'http://10.1.100.163:8001/simplydocApi'
    : 'http://10.1.100.216:8001/simplydocApi';
const API_LOCAL = 'http://127.0.0.1:8000/simplydocApi';
export const API_BASE_URL = window.location.port !== '8080' ? API_ENV : API_LOCAL;

export const GET_AUTHENTICATE = API_BASE_URL + '/ldapLogin/';
export const POST_REFRESH = API_BASE_URL + '/refresh/';
export const GET_VALIDATE = API_BASE_URL + '/validate';
export const GET_LOGOUT = API_BASE_URL + '/logoutUser';

export const GET_ZAHTJEVI = API_BASE_URL + '/getDocuments';
export const GET_DOCUMENT = API_BASE_URL + '/getDocument';

export const GET_ARCHIVED_DOCUMENTS = API_BASE_URL + '/getArchivedDocs';
export const GET_ARCHIVED_DOCUMENT = API_BASE_URL + '/getArchivedDoc';

export const DELETE_DOCUMENT = API_BASE_URL + '/deleteDocument';
export const DELETE_MULTIPLE_DOCUMENTS = API_BASE_URL + '/deleteDocuments';
export const SEARCH_DOCUMENTS = API_BASE_URL + '/searchDocuments/';
export const CONFIRM_DOCUMENT = API_BASE_URL + '/invoiceConfirmed';

export const GET_COMPANIES = API_BASE_URL + '/getCompanies';
export const POST_COMPANY = API_BASE_URL + '/newCompany/';
export const UPDATE_COMPANY = API_BASE_URL + '/updateCompany';

export const GET_USERS = API_BASE_URL + '/getUsers';
export const POST_USER = API_BASE_URL + '/newUser/';
export const UPDATE_USER = API_BASE_URL + '/updateUser';

export const GET_PROCESSES = API_BASE_URL + '/getProcesses';

export const POST_UPLOAD = API_BASE_URL + '/uploadFile';

export const GET_STATISTICS = API_BASE_URL + '/statistics/';

export const POST_SUBMIT_EMAIL_FORM = '/submitForm';

// export const LOGIN_URL = '/token/';
